import React, { useEffect, useState } from 'react'
import { BreadCrumbSecttion } from '../component/BreadCrumbSecttion'
import OtherService from '../services/Other'
import { Col, Container, Row } from 'react-bootstrap'
import Loader from '../component/Loader'
import { Link } from 'react-router-dom'
import { Search } from 'react-feather'
import ModalComponent from '../component/ModalComponent'
import NoData from '../component/NoData'

const DocumentLibrary = () => {
    const [loading, setLoading] = useState(true)
    const [isSelectedModal, setIsSelectedModal] = useState()
    const [isImageModalOpen, setIsImageModalOpen] = useState(false)
    const [imageTabNoData, setImageTabNoData] = useState(false)
    const [imageTab, setImageTab] = useState(true)
    const [videoTab, setVideoTab] = useState(false)
    const [documentTab, setDocumentTab] = useState(false)
    const handleTabClick = (tabName) => {
        setImageTab(tabName === 'Image')
        setVideoTab(tabName === 'Video')
        setDocumentTab(tabName === 'Document')
    }
    const [isImageList, setIsImageList] = useState([])
    const [isVideoList, setIsVideoList] = useState([])
    const [isDocList, setIsDocList] = useState([])
    useEffect(() => {
        const DocumentLibraryFetch = async () => {
            try {
                // const token = localStorage.getItem('access_token');
                const DocumentLibraryFetchResponse = await OtherService.uploadFileList();
                if (DocumentLibraryFetchResponse.success == true && DocumentLibraryFetchResponse.response.data.length > 0) {
                    const imageFiles = [];
                    const videoFiles = [];
                    const pdfFiles = [];

                    DocumentLibraryFetchResponse.response.data.forEach(file => {
                        if (file.file_type === 'image/jpeg') {
                            imageFiles.push(file);
                           
                        }
                        else if (file.file_type === 'video/mp4') {
                            videoFiles.push(file);

                        } else if (file.file_type === 'application/pdf') {
                            pdfFiles.push(file);
                        }

                    });
                    setIsImageList(imageFiles);
                    setIsVideoList(videoFiles);
                    setIsDocList(pdfFiles);
                    setLoading(false);
                    
                }
                else{
                    setLoading(false); 
                    setImageTabNoData(true);
                }
            }
            catch (error) {
                console.error('DocumentLibraryFetchResponse')
            }

        }
        DocumentLibraryFetch()
    }, [])
    const handlePdfClick = (pdfUrl) => {
        const link = document.createElement('a');
        link.href = pdfUrl; // Use the provided pdfUrl parameter
        link.target = '_blank';
        link.download = 'downloadedFile'; // Set the desired name for the downloaded file
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };
    const handleImgModal = ( modalItem) =>{
        setIsImageModalOpen(true)
        setIsSelectedModal(modalItem)
    }
    return (
        <>
            {loading && <Loader />}
            <BreadCrumbSecttion
                pageTitle="My Library"
                currentPageName="My Library" />
            <section className='padTop50'>
                <Container>
                    <Row>
                        <Col xs={12}>
                            <div className='notificationTabList'>
                                <ul>
                                    <li className={imageTab ? 'activeTab' : ''} onClick={() => handleTabClick('Image')}>
                                        <Link >Image</Link>
                                    </li>
                                    <li className={videoTab ? 'activeTab' : ''}onClick={() => handleTabClick('Video')}>
                                        <Link >Video</Link>
                                    </li>
                                    <li className={documentTab ? 'activeTab' : ''} onClick={() => handleTabClick('Document')}>
                                        <Link >Document</Link>
                                    </li>
                                </ul>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='userInfoBox'>
                                {imageTabNoData && <NoData />}
                                {!imageTabNoData && (
                                <div className="dashboard-details">
                                    {imageTab &&
                                        <Row className='docLibrary'>
                                            {isImageList?.map((item, index) => {
                                                return (
                                                    <Col xs={6} md={6} lg={3} key={index}>
                                                        <div className='itemWrap'>
                                                          <div className='magnifyBtn' onClick={()=>{handleImgModal(item)}}><Search/></div>
                                                            <div className='itemWrapImage'>
                                                               <img src={item?.file_path}  alt='image' className='img-fluid'/>
                                                            </div>
                                                        </div>
                                                        <div className="itemWrapImageTxt"><p>{item?.title}</p></div>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                    }
                                    {videoTab &&
                                       
                                        <Row className='docLibrary'>
                                            {isVideoList?.map((item, index) => {
                                                return (
                                                    <Col xs={6} md={6} lg={3} key={index}>
                                                        <div className='itemWrap'>
                                                            <div className='itemWrapImage'>
                                                            <iframe className="embed-responsive-item" src={item?.file_path}></iframe>
                                                            </div>
                                                        </div>
                                                        <div className="itemWrapImageTxt"><p>{item?.title}</p></div>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                    }
                                    
                                    {documentTab &&
                                        <Row className='docLibrary'>
                                        {isDocList?.map((item, index) => {
                                            return (
                                                <Col xs={6} md={6} lg={3} key={index}>
                                                    <div className='itemWrap'>
                                                    <div className='magnifyBtn' onClick={()=>{handlePdfClick(item.file_path)}}><Search/></div>
                                                        <div className='itemWrapImage'>
                                                        <iframe className="embed-responsive-item" src={item?.file_path}></iframe>
                                                        </div>
                                                    </div>
                                                    <div className="itemWrapImageTxt"><p>{item?.title}</p></div>
                                                   
                                                   
                                                </Col>
                                            )
                                        })}
                                    </Row>
                                    }
                                </div>)}
                            </div>
                        </Col>
                    </Row>
                </Container>
                {isSelectedModal && 
                <Container>
                    <Row>
                        <Col xs = {12} lg = {4}>
                            <ModalComponent
                             page='documentLibraryImageModal'
                             setIsModalOpen={setIsImageModalOpen}
                             isModalOpen={isImageModalOpen}
                             modalTitle= {isSelectedModal.title}
                             uploadImage = {isSelectedModal.file_path}
                            />
                        </Col>
                    </Row>
                </Container>
               }
            </section>
        </>
    )
}

export default DocumentLibrary